import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: string = 'english'

export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<string>) => action.payload,
  },
})

export const { setLanguage } = languageSlice.actions

export default languageSlice.reducer
